export default "__VITE_ASSET__DNtfMYFE__"